module.exports = __webpack_public_path__ + "img/noise_2.96328c8e.webp";